App.addModule(function(app) {
    
    if (!this.getConfigFlag('microsoft/bingads/uet_enabled') || !this.getConfig('microsoft/bingads/uet_tag_id') || !this.get('customer.can_track')) {
        return
    }

    this.onConsent('performance', () => {
    
        window.uetq = []

        this.loadScript('//bat.bing.com/bat.js', () => {

            uetq = new UET({
                ti: this.getConfig('microsoft/bingads/uet_tag_id'),
                q: uetq
            })
            
            uetq.push('pageLoad')
        })
        
        uetq.push('consent', 'update', {ad_storage: 'granted'})

        const order = app.get('checkout.order')

        if (order) {
		    
            uetq.push('event', '', {
           		revenue_value: app.round(order.base_subtotal, 2),
           		currency: order.base_currency_code
           	})
	    }
    })
})
